module.exports = __webpack_public_path__ + "img/1473229642.27347cb7.jpg";